import { render, staticRenderFns } from "./ServiceItemPortrait.vue?vue&type=template&id=4f5ee5d7&scoped=true&"
import script from "./ServiceItemPortrait.vue?vue&type=script&lang=js&"
export * from "./ServiceItemPortrait.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemPortrait.vue?vue&type=style&index=0&id=4f5ee5d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ee5d7",
  null
  
)

export default component.exports